import { useQuery } from "@tanstack/react-query";
import { publicApi } from "@/lib/api";
import { queryKeys } from "./keys";

export function usePublicHealth() {
  return useQuery({
    queryKey: queryKeys.publicApi.health,
    queryFn: publicApi.getPublicHealth,
    retry: 1,
    staleTime: 15_000,
  });
}

export function useEmergencyState() {
  return useQuery({
    queryKey: queryKeys.publicApi.emergencyState,
    queryFn: publicApi.getEmergencyState,
    retry: 1,
    staleTime: 15_000,
  });
}
